module.exports = __webpack_public_path__ + "static/media/link-horizontal.c5079998.svg";